/*
 * @Author: 
 * @Date: 2021-01-11 09:30:38
 * @LastEditors: 诺
 * @LastEditTime: 2022-12-28 14:46:39
 * @Description: file content
 * 
 */
export default {
    protocol: "",
    domain: "",
    action: {
        // 页面配置信息 -ui
        getConfig: {
            api: "circle-act-game-lucky/act/page/getConfig",
            method:'get',
            contentType:'json',
            mock: function () {
                return {
                    msg: "success",
                    code: 0,
                    data: {
                        value: "这里是假数据"
                    }
                }
            }
        }
    },
}